import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import { Option } from '../../types/option'

import * as S from './styles'
import { Controller, useFormContext } from 'react-hook-form'
import { CustomRadioButton } from '../CustomRadioButton'
import { MedicalRecordFormData } from '../../medicalRecordSchema'
import { RadioButtonErrorWrapper } from '../RadioButtonErrorWrapper'

const radioOptions: Option[] = [
  { id: 'psychiatrist-treatment-yes', name: 'Sim' },
  { id: 'psychiatrist-treatment-no', name: 'Não' },
]

export function PsychiatristTreatment(): JSX.Element {
  const {
    control,
    formState: { errors },
  } = useFormContext<MedicalRecordFormData>()

  const errorMessage = errors.has_psychiatrist_treatment?.message

  return (
    <S.PsychiatristTreatmentContainer>
      <Typography weight='bolder' variant='content2'>
        Faz acompanhamento psiquiátrico? *
      </Typography>
      <RadioButtonErrorWrapper errorMessage={errorMessage}>
        <S.RadioButtonOptions>
          {radioOptions.map((option) => (
            <Controller
              key={option.id}
              control={control}
              name='has_psychiatrist_treatment'
              render={({ field }) => (
                <CustomRadioButton
                  {...field}
                  key={option.id}
                  id={option.id as string}
                  onChange={() => field.onChange(option.id)}
                  label={
                    <Typography variant='content2'>{option.name}</Typography>
                  }
                  hasError={!!errorMessage}
                />
              )}
            />
          ))}
        </S.RadioButtonOptions>
      </RadioButtonErrorWrapper>
    </S.PsychiatristTreatmentContainer>
  )
}
